$(document).ready(function() {

//$('.price-list').addClass('inactive');


function updateDiscountMessage(count) {
       let message = "";
    // Reset the active state on all points and lines

    if (count < 2) {
    message = `<div class="message1">Select ${2 - count} more,</div><div class="message2"> save an additional 20%</div><div class="message3">on a set of 2 or more.</div>`;
} else if (count < 4) {
        message = `<div class="message1">Select ${4 - count} more,</div><div class="message2"> save an additional 30%</div><div class="message3">on a set of 4 or more.</div>`;
    } else if (count < 6) {
         message = `<div class="message1">Select ${6 - count} more,</div><div class="message2"> save an additional 40%</div><div class="message3">on a set of 6 or more.</div>`;
    } else if (count < 8) {
         message = `<div class="message1">Select ${8 - count} more,</div><div class="message2"> save an additional 60%</div><div class="message3">on a set of 8 or more.</div>`;
    } else {
      message = `<div class="message2">You're saving an additional 60%</div><div class="message3">on your set of ${count}</div>`;
    }

     $('.product-page-buy-more-container').html(message).addClass('active');
}



  
    // Handle 'pointerup' events on labels with IDs containing 'Artwork'
    $(document).on('pointerup', '.tpo_option-type-color-swatches-wrapper > .tpo_buttons-wrapper label:has(input[id*="Artwork"])', function() {
        var currentState = $(this).attr('data-clicked') === 'true';
        $(this).attr('data-clicked', !currentState);

        var quantityInput = $('.tpo_quantity-selector_input');
        var currentQuantity = parseInt(quantityInput.val()) || 0;
        var count = $('.tpo_option-type-color-swatches-wrapper label[data-clicked="true"]:has(input[id*="Artwork"])').length;

    

        if (!currentState) {

           $('.price-list').addClass('active').removeClass('inactive');
          updateDiscountMessage(count);

          
            $('.tpo_swatches-label_position').each(function() {
             var swatches_label_id = $(this).find('.tpo_color-swatches-input').filter(function() {
    return this.id.includes('Mat Option') || this.id.includes('Frame');
}).attr('id');
                if ($(this).hasClass('swatches-selected')) {
                  //console.log('#### '+swatches_label_id+': plus clicked');
                    $(this).find('.tpo_quantity-selector_plus').click();
                } else {
                  // console.log('#### '+swatches_label_id+': plus incremented');
                    var input = $(this).find('.tpo_quantity-selector_input');
                    var currentValue = parseInt(input.val(), 10) || 0;
                    input.val(currentValue + 1);
                }
            });
        } else {
            if (count == 0) {
                          $('.tpo_swatches-label_position').each(function() {
             var swatches_label_id = $(this).find('.tpo_color-swatches-input').filter(function() {
    return this.id.includes('Mat Option') || this.id.includes('Frame');
}).attr('id');
                           // console.log('#### '+swatches_label_id+': zero');
                            $(this).find('.tpo_quantity-selector_input').val(0);
               
            });
             
            } else {
            

                $('.tpo_swatches-label_position').each(function() {
                           var swatches_label_id = $(this).find('.tpo_color-swatches-input').filter(function() {
    return this.id.includes('Mat Option') || this.id.includes('Frame');
}).attr('id');
                if ($(this).hasClass('swatches-selected')) {
                  // console.log('#### '+swatches_label_id+': minus clicked');
                    $(this).find('.tpo_quantity-selector_minus').click();
                } else {
                  //console.log('#### '+swatches_label_id+': minus incremented');
                    var input = $(this).find('.tpo_quantity-selector_input');
                    var currentValue = parseInt(input.val(), 10) || 0;
                    input.val(currentValue - 1);
                }
            });
            }

          

          
        }
    });

    // Custom checkboxes handling
    $(document).on('click', '.custom-checkboxes', function(event) {
        const container = $(this).closest('.tpo_option-container');
        container.find('.custom-checkboxes').not(this).prop('checked', false).parent('.tpo_swatches-label_position').removeClass('swatches-selected');
        const element = $(this).next('label');
        const swatchPosition = $(this).parent('.tpo_swatches-label_position');

        if ($(this).prop('checked')) {
            swatchPosition.addClass('swatches-selected');
        } else {
            swatchPosition.removeClass('swatches-selected');
        }

        element[0].dispatchEvent(new PointerEvent('pointerup', { bubbles: true, cancelable: true }));
    });

    // Toggle checked state for label click
    $(document).on('click', '.tpo_swatches-label_position > label', function(event) {
        var checkbox = $(this).prev('.custom-checkboxes');
        checkbox.prop('checked', !checkbox.prop('checked'));
    });

    // Mutation observer for dynamic content changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && $(mutation.target).hasClass('buy-buttons')) {
               
                $('.tpo_add-to-cart').addClass('inactive');
              $('.shopify-payment-button').addClass('inactive');
                $('.tpo_option-type-image-swatches-wrapper .tpo_swatches-label_position:has(> label > input[id*="Mat Option"], > label > input[id*="Frame"]) > .tpo-quantity_always-show > .tpo_quantity-selector_wrapper > .tpo_quantity-selector_input').val(0);
                $('.tpo_option-type-image-swatches-wrapper .tpo_swatches-label_position:has(> label > input[id*="Mat Option"], > label > input[id*="Frame"]) > label > input').each(function() {
                    if (!$(this).is('input[type="checkbox"]')) {
                        $(this).parent('label').before('<input type="checkbox" class="tpo_color-swatches-input custom-checkboxes">');
                    }
                });
            }
        });
    });

    const config = { childList: true, subtree: true };
    const targetNode = document.querySelector('.buy-buttons');
    if (targetNode) {
        observer.observe(targetNode, config);
    } else {
        console.error('.buy-buttons not found');
    }
});



$(document).ready(function() {
  // Show the popup when a collection link is clicked
  $('.sp-collection-list-item2').on('click', function(event) {
    var data_image_1 = $(this).find('.sp-button-link').attr('data-popup-image-1');
    var data_image_2 = $(this).find('.sp-button-link').attr('data-popup-image-2');
    var data_url_1 = $(this).find('.sp-button-link').attr('data-popup-url-1');
    var data_url_2 = $(this).find('.sp-button-link').attr('data-popup-url-2');
    console.log('data_image_1: '+data_image_1);
    $('#btn-curated-set').attr('href',data_url_1);
    $('#btn-single-print').attr('href',data_url_2);
    $('#popup-image1').attr('src',data_image_1);
    $('#popup-image2').attr('src',data_image_2);
    $('#popup-modal').fadeIn().css('display','flex');

    
  });

  // Close the popup when the close button is clicked
  $('.close-popup').on('click', function() {
    $('#popup-modal').fadeOut();
  });

  // Close the popup if the user clicks outside the popup content
  $(window).on('click', function(event) {
    if ($(event.target).is('#popup-modal')) {
      $('#popup-modal').fadeOut();
    }
  });
});



// #variant-size-description
// #variant-size-description-data
// .variant-size-description-item
// .variant-size-description-item-2
$(document).ready(function () {
  function updateVariantDisplay() {
    // Read currently selected option labels
    var option1 = $('input[name*="option1"]:checked').next('label').text().trim();
    var option2 = $('input[name*="option2"]:checked').next('label').text().trim();

    var $summary = $('.variant-size-summary');
    var $details = $('.variant-size-details');

    if (!$summary.length || !$details.length) {
      console.warn('Variant size description containers not found');
      return;
    }

    // Build heading: "Large - Art Print"
    var summaryText = '';
    if (option1 && option2) {
      summaryText = option1 + ' - ' + option2;
    } else if (option1) {
      summaryText = option1;
    } else if (option2) {
      summaryText = option2;
    }

    $summary.text(summaryText);

    // Find matching hidden description by option1 / option2
    var $source = $('#variant-size-description-data .variant-size-description-item').filter(function () {
      var o1 = $(this).data('option1');
      var o2 = $(this).data('option2');
      return o1 === option1 && o2 === option2;
    });

    console.log('Updating for:', summaryText, '| matches:', $source.length);

    if ($source.length) {
      // Copy rich HTML (metafield_tag output) into the visible details container
      $details.html($source.html());
    } else {
      $details.empty();
    }
  }

  // On initial load
  updateVariantDisplay();

  // When user changes size or framing radios
  $(document).on('change', 'input[name*="option"]', function () {
    updateVariantDisplay();
  });
});











